import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notify } from '@/ui/snackbar/notify';
import { toggleOrganizationEditorsChoice } from '@/api/v4/organization.api';
import { useAtomValue } from 'jotai';
import { companyIdState } from '@/features/companies/overview/company.state';
import { useCompanyFetchMode } from '@/features/companies/overview/company-fetch-context';
import { QueryKey } from '@/config/query-client';

export const useToggleEditorsChoice = () => {
  const { t } = useTranslation('companies');
  const queryClient = useQueryClient();
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  const mutation = useMutation({
    mutationFn: async () => {
      if (!companyId) return;
      return toggleOrganizationEditorsChoice(companyId);
    },
    onSuccess: async data => {
      if (data) {
        notify({
          message: data.isEditorsChoice
            ? t('company.editorsChoice.selectedAsEditorsChoice', {
                companyName: data.name,
              })
            : t('company.editorsChoice.unselectedAsEditorsChoice', {
                companyName: data.name,
              }),
        });
      }
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.Company, fetchMode, companyId],
      });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Companies] });
    },
    onError: () => {
      notify({
        message: t`company.editorsChoice.error`,
      });
    },
  });

  return {
    toggleEditorsChoice: mutation.mutateAsync,
  };
};
